export default __webpack_public_path__ + "static/media/ic_cheveron_right.2e5afbca.svg";